<template>
    <FormItem :label="title">
        <div style="margin-bottom: 20px;">
            <Upload v-show="uploadList.length == 0 && !currentValue"
                    ref="upload"
                    :max-size="20480"
                    :on-exceeded-size="handleMaxSize"
                    :on-success="uploadSuccess"
                    :before-upload="handleBeforeUpload"
                    :format="['mp4']"
                    :headers="{'x-token':$store.getters.token }"
                    action="/supervise/admin/upload/uploadFile">
                <Button icon="ios-cloud-upload-outline">上传视频</Button>
            </Upload>
            <Progress v-if="uploadList.length>0&&uploadList[0].status!='fnished'&&uploadList[0].showProgress" :percent="uploadList[0].percentage" hide-info></Progress>
            <Button v-if="!!currentValue" @click="handleView(currentValue)">查看视频</Button>
        </div>
        <Modal title="查看视频" v-model="visible" width="900" :footer-hide="true">
            <video :src="videoUrl|prepandImg" controls="controls" style="width:100%;max-height:800px;"></video>
        </Modal>

    </FormItem>
</template>

<script>
    import mixins from './mixins'

    const currentModal = {
        type: 'video',
        url: '',
        text: '',
        img_url: ''
    };

    export default {
        name: "do-video",
        mixins: [mixins],
        uploadList: [],
        data() {
            return {
                currentValue: null,
                uploadList: [],
                visible:false,
                videoUrl:''
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.uploadList = this.$refs.upload.fileList;
            });
        },
        methods: {
            handleView(url) {
                this.videoUrl = url;
                this.visible = true;
            },
            uploadSuccess(res) {
                if (res.success){
                    this.currentValue = '/'+res.data.path;
                } else if (res.message == '-5') {
                    this.$store.dispatch('Logout').then(() => {
                        this.$router.push('/login');
                    });
                } else {
                    this.$Message.error(res.message||'未知错误')
                }
            },
            handleBeforeUpload() {
                console.log(this.$refs.upload.fileList)
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: '尺寸错误',
                    desc: '视频  ' + file.name + ' 尺寸太大, 必须小于 20M.'
                });
            },
            handleRemove() {
                this.$refs.upload.fileList.length > 0 && this.$refs.upload.fileList.splice(0, 1);
                this.currentValue=''
            }
        },
        filters:{
            prepandImg(url){
                if(url){
                    return '/supervise'+url
                }
                return null
            }
        }
    }
</script>
